module.exports = __webpack_public_path__ + "f072b5fe.png";